export * from './media.component';
export * from './media-create/media-create.component';
export * from './media-list/media-list.component';
export * from './media-statistic/media-statistic.component';
export * from './media-update/media-update.component';

